export const chart = {
  chartWithoutData: 'Sorry, there is \nno data available.',
  nationalAverage: 'National average',
};
